import React, { useEffect, useState } from "react";
import logoutimg from "../../../assets/images/logout.png";
import imagebk from "../../../assets/images/back.png";
import switchOnimg from "../../../assets/images/switch_on_icon.png";
import RequestList from "../IL1";
import SuperAdminApprovalRequestList from "../SwitchOnSuperAdminViewApprovalList";
import AddRequestForm from "../SwitchOnIdeaGeneration";

import IL2 from "../IL2";
import IL4 from "../IL4";
import IL1Admin from "../IL1AdminView";
import UserShowingRequestForm from "../SwitchOnUserIdeaList";
import IL3StageView from "../IL3Stage";
import AssignedByPD from "../AssignedByPD";
import bggif from "../../../assets/images/BG-switch loader_2.gif";
import ExcelFile from "../2B2/index";
import Testing from "../Testing/index";
import IL5ExcelFile from "../IL5/il5_generate_excel";
import IL4AdminView from "../IL4AdminView";
import IL5AdminView from "../IL5AdminView";
import TwoB2AdminView from "../2B2AdminView";



import {
  allowedEmpIdsForIL1,
  iL1ReassignEmpIds,
  allowedEmpIdsForIL2,
  allowedEmpIdsFor2b2,
  adminEmpIds,
  il4EmpIds,
  il5EmpIds,
  il2ViewAccess

} from "../switch_on_userlist";

import "./index.css";
function SwitchOnHomePage() {
  const [isloading, Setisloading] = useState(false);
  useEffect(() => {
    const emp_id = localStorage.getItem("empid");
    if (!emp_id) {
      window.location.href = "/login";
    }
  }, []);

  const redirectTodashboard = () => {
    window.location.href = "/landingPage";
  };

  const redirectToLogin = () => {
    window.location.href = "/login";
  };

  const [activeTab, setActiveTab] = useState("add");

  const empId = localStorage.getItem("empid");

  return (
    <div className="bg_set_time">
   {isloading ? (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.3)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <div className="loadergif">
              <img src={bggif} alt="Loading..." />
            </div>
          </div>
        ) : (
          ""
        )}
      <div className="switch">
        {/* Header section */}

        <img
          className="switch-back"
          onClick={redirectTodashboard}
          src={imagebk}
          alt="Back"
        />

        <img className="switch-img" src={switchOnimg} alt="Switch On" />
        <img
          className="logout-img"
          title="Logout"
          onClick={redirectToLogin}
          src={logoutimg}
          alt="Logout"
        />
      </div>

      <br />
      <br />

      <div className="row justify-content-center tabdesign_vm">
        <div
          className={`col-md-2 text-center ${
            activeTab === "add" ? "tabfirst-selected" : "notselected"
          }`}
          onClick={() => setActiveTab("add")}
        >
          Idea Generation
        </div>

        <div
          className={`col-md-2 text-center ${
            activeTab === "view" ? "tabfirst-selected" : "notselected"
          }`}
          onClick={() => setActiveTab("view")}
        >
          Your Idea
        </div>

        {/* {iL1ReassignEmpIds.includes(empId) && (
          <div
            className={`col-md-2 text-center ${
              activeTab === "accept" ? "tabfirst-selected" : "notselected"
            }`}
            onClick={() => setActiveTab("accept")}
          >
            IL2
          </div>
        )} */}

        {allowedEmpIdsForIL1.includes(empId) && (
          <div
            className={`col-md-2 text-center ${
              activeTab === "accept" ? "tabfirst-selected" : "notselected"
            }`}
            onClick={() => setActiveTab("accept")}
          >
            IL2
          </div>
        )}

        {allowedEmpIdsFor2b2.includes(empId) && (
          <div
            className={`col-md-2 text-center ${
              activeTab === "2b2" ? "tabfirst-selected" : "notselected"
            }`}
            onClick={() => setActiveTab("2b2")}
          >
            2B2
          </div>
        )}

        {/* {allowedEmpIdsForIL2.includes(empId) && (
          <div
            className={`col-md-2 text-center ${
              activeTab === "il2" ? "tabfirst-selected" : "notselected"
            }`}
            onClick={() => setActiveTab("il2")}
          >
            IL2
          </div>
        )} */}

        {allowedEmpIdsForIL2.includes(empId) && (
          <div
            className={`col-md-2 text-center ${
              activeTab === "il2" ? "tabfirst-selected" : "notselected"
            }`}
            onClick={() => setActiveTab("il2")}
          >
            IL3
          </div>
        )}
    {allowedEmpIdsFor2b2.includes(empId) && (
          <div
            className={`col-md-2 text-center ${
              activeTab === "testing" ? "tabfirst-selected" : "notselected"
            }`}
            onClick={() => setActiveTab("testing")}
          >
            Testing
          </div>
         )} 
        {il4EmpIds.includes(empId) && (
          <div
            className={`col-md-2 text-center ${
              activeTab === "il4" ? "tabfirst-selected" : "notselected"
            }`}
            onClick={() => setActiveTab("il4")}
          >
            IL4
          </div>
        )}

        {/* {allowedEmpIdsForIL2.includes(empId) && (
          <div
            className={`col-md-2 text-center ${
              activeTab === "il5" ? "tabfirst-selected" : "notselected"
            }`}
            onClick={() => setActiveTab("il5")}
          >
            IL5
          </div>
        )}   */}

       {il5EmpIds.includes(empId) && (
          <div
            className={`col-md-2 text-center ${
              activeTab === "IL5" ? "tabfirst-selected" : "notselected"
            }`}
            onClick={() => setActiveTab("IL5")}
          >
            IL5
          </div>
        )} 



        {allowedEmpIdsForIL1.includes(empId) && (
          <div
            className={`col-md-2 text-center ${
              activeTab === "AssignedByPD" ? "tabfirst-selected" : "notselected"
            }`}
            onClick={() => setActiveTab("AssignedByPD")}
          >
            IL2 Assigned
          </div>
        )}  
     {(adminEmpIds.includes(empId) || il2ViewAccess.includes(empId)) && (
          <div
            className={`col-md-2 text-center ${
              activeTab === "IL1 admin" ? "tabfirst-selected" : "notselected"
            }`}
            onClick={() => setActiveTab("IL1 admin")}
          >
            IL2 Approvals
          </div>
        )}
        {adminEmpIds.includes(empId) && (
          <div
            className={`col-md-2 text-center ${
              activeTab === "2B2 admin" ? "tabfirst-selected" : "notselected"
            }`}
            onClick={() => setActiveTab("2B2 admin")}
          >
            2B2 Approvals
          </div>
        )}
      {(adminEmpIds.includes(empId) || empId === "300558") && (
          <div
            className={`col-md-2 text-center ${
              activeTab === "IL3" ? "tabfirst-selected" : "notselected"
            }`}
            onClick={() => setActiveTab("IL3")}
          >
            IL3 Approvals
          </div>
        )}
  {adminEmpIds.includes(empId) && (
          <div
            className={`col-md-2 text-center ${
              activeTab === "IL4 admin" ? "tabfirst-selected" : "notselected"
            }`}
            onClick={() => setActiveTab("IL4 admin")}
          >
            IL4 Approvals
          </div>
        )}
     {adminEmpIds.includes(empId)  && (
          <div
            className={`col-md-2 text-center ${
              activeTab === "IL5 admin" ? "tabfirst-selected" : "notselected"
            }`}
            onClick={() => setActiveTab("IL5 admin")}
          >
            IL5 Approvals
          </div>
        )}
      </div>

      <div className="scrollable-content standard-layout">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              {/* {activeTab === "add" && <AddRequestForm mode="add" />} */}
              {activeTab === "add" && (
                <AddRequestForm Setisloading={Setisloading} />
              )}
              {activeTab === "view" && <UserShowingRequestForm />}
              {activeTab === "accept" && (
                <RequestList
                  role={"Admin"}
                  //  setIsLoading= {Setisloading}
                />
              )}
              {activeTab === "il2" && <IL2 />}
              {activeTab === "il4" && <IL4 />}
              {activeTab === "2b2" && <ExcelFile />}
              {activeTab === "IL3" && <SuperAdminApprovalRequestList />}
              {activeTab === "AssignedByPD" && <AssignedByPD />}
              {activeTab === "IL1 admin" && <IL1Admin />}
              {activeTab === "IL5" && <IL5ExcelFile />}
              {activeTab === "testing" && <Testing />}
              {activeTab === "IL4 admin" && <IL4AdminView />}
              {activeTab === "IL5 admin" && <IL5AdminView />}
              {activeTab === "2B2 admin" && <TwoB2AdminView />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SwitchOnHomePage;
